// extracted by mini-css-extract-plugin
export default {"center":"TableCell_center__sHlIE","text":"TableCell_text__XnzZE"};